import { numberRequiredSchema, select2RequiredSchema, stringRequiredSchema } from "utils/validation/validationHelpers";
import { object } from 'yup';

const editAssignedTherapistSchema = object().shape({
    assessment_date: stringRequiredSchema,
    meeting_time: stringRequiredSchema,
});

export default editAssignedTherapistSchema;